import { isCodelessEventsApp } from 'modules/codeless-events/utils/isCodelessEventsApp';

export const isIframeMode = () => window.parent !== window && !isCodelessEventsApp();
